import React from 'react';
import { Navigate } from 'react-router-dom';
import { COMPANY_ARTIFACTS_SELECT_PATH } from '../../utils/companyArtifactRoutes';

/** Legacy `/artifacts/select-tree` → `/artifacts/artifact-tree`. */
const CompanyArtifactsSelectTreeRedirect: React.FC = () => {
  return <Navigate to={COMPANY_ARTIFACTS_SELECT_PATH} replace />;
};

export default CompanyArtifactsSelectTreeRedirect;
